module.exports = __webpack_public_path__ + "img/18_u.74ab5450.jpg";